export const ELECTRICITY_CONTRACT_DATA_SESSION_STORAGE_KEY = 'electricity-contract-data';
export const FORM_STAGES = {
    SELECT_PRODUCT_STAGE: 1,
    FILL_OUT_FORM_STAGE: 2,
    THANK_YOU_STAGE: 3,
}
